module.exports = __webpack_public_path__ + "img/active-past3.d9a1bcf5.jpg";